var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters.vendor.storeUI||_vm.$store.getters.vendor.storeUI==_vm.oldStoreUI)?_c('old-store-layout'):(_vm.$store.getters.vendor.storeUI==_vm.newStoreUI)?_c('new-store-layout'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }